import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { ReleaseFirmwareVersion } from 'src/app/releases/services/release.service';

@Component({
  selector: 'firmware-version-search',
  templateUrl: './firmware-version-search.component.html',
  styleUrls: ['./firmware-version-search.component.scss'],
})
export class FirmwareSearchComponent implements OnInit {
  @Input() placeHolder: string;
  @Input() firmwareVersions: ReleaseFirmwareVersion[];
  @Input() displayFirmwareVersion: string;
  @Output() firmwareVersion: EventEmitter<ReleaseFirmwareVersion> =
    new EventEmitter<ReleaseFirmwareVersion>();
  @ViewChild('input', { static: false }) input: ElementRef;
  selectedFirmwareVersion: ReleaseFirmwareVersion[] = [];

  searchFirmwareVersionBinding: (
    searched: Observable<string>,
  ) => Observable<ReleaseFirmwareVersion[]>;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.searchFirmwareVersionBinding = this.searchFirmwareVersions.bind(this);
  }

  searchFirmwareVersions = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term: string) =>
        term.length < 2
          ? []
          : this.firmwareVersions.filter(
              (firmwareVersion) =>
                firmwareVersion.name
                  .toLowerCase()
                  .includes(term.toLowerCase()) ||
                (firmwareVersion.version
                  .toLowerCase()
                  .includes(term.toLowerCase()) &&
                  !this.selectedFirmwareVersion.includes(firmwareVersion)),
            ),
      ),
    );

  onSelectItem(event: any) {
    this.firmwareVersion.emit(event.item);
    this.selectedFirmwareVersion.push(event.item);

    //Clear the typeahead input field
    event.preventDefault?.();
    this.input.nativeElement.value = '';
    this.cdr.detectChanges();
  }

  formatter = (result: { name: string; version: string }) =>
    result.name + ' (' + result.version + ')';

  formatModule(firmware: ReleaseFirmwareVersion): string {
    const firmwareStringList = [];
    firmwareStringList.push(firmware.name);
    firmwareStringList.push(firmware.version);

    try {
      return firmwareStringList.join(' > ');
    } catch (e) {
      return '';
    }
  }
}
